import type {
  APIRequestBody,
  APIRequestPathParams,
  APIResponse,
} from './base-fetch';
import { get, post } from './base-fetch';

export type AccountResponse = APIResponse<'/api/v4/accounts/{accountId}'>;

export const fetchAccount = (accountId: string) =>
  get<AccountResponse>(`/v4/accounts/${accountId}`);

export type EditAccountPayload = APIRequestBody<'/api/v4/accounts/edit'>;

export const editMyAccount = (payload: EditAccountPayload) =>
  post<void>(`/v4/accounts/edit`, payload);

export type RequestProjectUrlResponse =
  APIResponse<'/api/v4/accounts/request-project-url'>;

export const getRequestProjectUrl = () =>
  get<RequestProjectUrlResponse>('/v4/accounts/request-project-url');

export type SpotlightUrlResponse =
  APIResponse<'/api/v4/accounts/spotlight-url'>;

export const getSpotlightUrl = () =>
  get<SpotlightUrlResponse>('/v4/accounts/spotlight-url');

export type ValidateShareLinkParams =
  APIRequestPathParams<'/api/v4/accounts/validate-share-link/{linkId}'>;

export type ValidateShareLinkResponse =
  APIResponse<'/api/v4/accounts/validate-share-link/{linkId}'>;

export const validateShareLink = ({ linkId }: ValidateShareLinkParams) =>
  get<ValidateShareLinkResponse>(`/v4/accounts/validate-share-link/${linkId}`);
